import { api } from '../api';
import { h } from '../ui/dom';
import { safeMessage } from './shared/safe';
import { downloadText } from './shared/download';
type Counts = {
    active: number;
    planned: number;
    uncertain: number;
    deliveredUninspected: number;
    observed: number;
    absent: number;
};
export async function reportsView(root: HTMLElement) {
    const status = h('p', { role: 'status' }, 'Loading reports…'), client = h('select', { 'aria-label': 'Report client' }, h('option', { value: '' }, 'Select a client')), month = h('input', { type: 'month', 'aria-label': 'Report month', value: new Date().toISOString().slice(0, 7) }), run = h('button', { type: 'button' }, 'Read monthly report'), result = h('section');
    root.replaceChildren(h('h1', null, 'Reports'), h('p', null, 'Monthly recorded delivery activity and the current created-link ledger are separate. Historical receipts remain available after replacement or account changes. HTTP 200 alone does not prove that a link exists.'), client, month, run, status, result);
    try {
        const data = await api<{
            clients: {
                id: string;
                business_name: string;
            }[];
        }>('/v1/clients?limit=200');
        for (const c of data.clients)
            client.append(h('option', { value: c.id }, c.business_name));
        status.textContent = 'Select a client and month. Agency current counts are available in Created links.';
    }
    catch (e) {
        status.textContent = safeMessage(e instanceof Error ? e.message : e);
    }
    root.append(h('div', { class: 'btn-group cp-report-links' }, h('a', { class: 'btn secondary', href: '#/links' }, 'Created-link summary'), h('a', { class: 'btn secondary', href: '#/campaigns' }, 'Campaign progress')));
    run.onclick = async () => {
        if (!client.value || !month.value) {
            status.textContent = 'Select a client and valid month.';
            return;
        }
        run.disabled = true;
        status.textContent = 'Reading recorded evidence…';
        try {
            const report = await api<{
                capturedAt: number;
                note: string;
                clientSafe: {
                    summary: string;
                    articlesPublished: number;
                    createdLinks: Counts;
                };
                internal: {
                    aiSpendCents: number;
                };
                activity: {
                    providerReceipts: number;
                    historicalReceipts: number;
                    campaigns: {
                        campaign_id: string;
                        name: string;
                        state: string;
                        intentions: number;
                    }[];
                };
                history: {
                    receipts: {
                        providerUrl: string;
                        counted: false;
                        reason: string;
                        links: {
                            sourceUrl: string;
                            href: string;
                        }[] | null;
                    }[];
                };
            }>(`/v1/reports/${encodeURIComponent(client.value)}?month=${encodeURIComponent(month.value)}`);
            const counts = report.clientSafe.createdLinks, dl = h('dl');
            for (const [name, value] of Object.entries(counts))
                if (typeof value === 'number')
                    dl.append(h('dt', null, name), h('dd', null, value));
            const exportJson = h('button', { type: 'button' }, 'Download captured report');
            exportJson.onclick = () => downloadText(JSON.stringify(report, null, 2), 'application/json', `cloudpush-report-${month.value}.json`);
            result.replaceChildren(h('h2', null, 'Client summary'), h('p', null, report.clientSafe.summary), h('p', null, report.note), h('h3', null, 'Current created links'), dl, h('h3', null, 'Monthly activity'), h('p', null, `${report.activity.providerReceipts} provider receipts · ${report.clientSafe.articlesPublished} approved masters delivered · ${report.activity.historicalReceipts} historical receipts · AI spending ${report.internal.aiSpendCents}¢`), h('p', null, `Captured ${new Date(report.capturedAt * 1000).toLocaleString()}. Download this capture to preserve what was reported at this time.`), exportJson, h('h3', null, 'Campaigns'), ...report.activity.campaigns.map(c => h('p', null, h('a', { href: '#/campaigns' }, c.name), ` · ${c.state} · ${c.intentions} scheduled intentions`)), h('h3', null, 'Historical receipt evidence'));
            for (const r of report.history.receipts)
                result.append(h('details', null, h('summary', null, 'Historical receipt (not counted as current)'), h('a', { href: r.providerUrl, target: '_blank', rel: 'noopener noreferrer' }, r.providerUrl), h('p', null, r.reason), ...(r.links ?? []).map(l => h('p', null, l.sourceUrl, ' → ', l.href))));
            result.append(h('a', { href: `#/clients/${encodeURIComponent(client.value)}/links` }, 'Filter and export exact created links'));
            status.textContent = 'Report loaded from recorded evidence. Publication receipts are separate from live-link inspection.';
        }
        catch (e) {
            status.textContent = safeMessage(e instanceof Error ? e.message : e);
        }
        finally {
            run.disabled = false;
        }
    };
}
